import {
    EhrAccessBlacklistEntryListResponse,
    EhrAccessBlacklistQuery,
    EhrAccessGrantListQuery,
    EhrAccessGrantListResponse,
    EhrAccessHasManyResponse,
    EhrAccessMemberData,
    EhrAccessOwnEhrsResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/ehr-access';

export class EhrAccessApi {
    public static async hasMany(ehrIds: string[]): Promise<EhrAccessHasManyResponse> {
        const res = await axios.post<EhrAccessHasManyResponse>(`${BASE_URL}/me/has-many`, { ehrIds });

        return res.data;
    }

    public static async grants(query: EhrAccessGrantListQuery): Promise<EhrAccessGrantListResponse> {
        const res = await axios.get<EhrAccessGrantListResponse>(`${BASE_URL}/grants`, { params: query });

        return res.data;
    }

    public static async blacklist(query: EhrAccessBlacklistQuery): Promise<EhrAccessBlacklistEntryListResponse> {
        const res = await axios.get<EhrAccessBlacklistEntryListResponse>(`${BASE_URL}/blacklist`, { params: query });

        return res.data;
    }

    public static async members(ehrId: string): Promise<EhrAccessMemberData[]> {
        const res = await axios.get<EhrAccessMemberData[]>(`${BASE_URL}/${ehrId}/members`);

        return res.data;
    }

    public static async ownEhrIds(userId: string): Promise<string[]> {
        const res = await axios.get<EhrAccessOwnEhrsResponse>(`${BASE_URL}/users/${userId}/own-ehrs`);

        return res.data.ehrIds;
    }

    public static async linkOwnEhr(userId: string, ehrId: string): Promise<void> {
        await axios.post(`${BASE_URL}/users/${userId}/own-ehrs`, { ehrId });
    }

    public static async unlinkOwnEhr(userId: string, ehrId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/users/${userId}/own-ehrs/${ehrId}`);
    }
}
